(function (fox, $) {

	fox.registerWidget('BillingSupport_Cancellation', {

		configure: function () {

			this.registerOptions('', {
				widgets: {
					modelText: {
						widget: 'Widget',
						container: '.cite',
						autoRender: true,
						template: 'billingSupport_cancellation_cite'
					},

					cancellationForm: {
						widget: 'BillingSupport_CancellationForm'
					},

					// overlay: {
					// 	widget: 'Widget',
					// 	embed: {
					// 		widget: '@parent @parent @parent @parent',
					// 		location: 'lastChild',
					// 		container: '.wrapper'
					// 	},
					// 	autoRender: true,
					// 	template: 'billingSupport_cancellation_overlay'
					// }
				},
				'handleWom.showOffer': {
					widget: '#modelText',
					event: 'addedToDom',
					listenHistory: true,
					callback: function () {
						fox.UserOffer.checkAction('preCancel');
					}
				}
			});

			this.callParent('configure', arguments)
		},

		activating: function () {
			this.setDiscount();
			this.callParent('running', arguments);
		},

		setDiscount: function () {
			var sendApi = this.getApi('retentionPolicy', {
				method: 'retentionPolicy.get'
			});
			return sendApi.psend().then((resp) => {
				this.cancellationDiscount = (fox.isEmpty(resp.params.answer.response)) ? false : resp.params.answer.response;
				return true;
			}).catch((error) => {
				this.cancellationDiscount = false;
				console.error(error);
			});
		},

	}, 'Controller');

})(fox, jQuery);


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/billingSupport/cancellation.es.js